"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  primary: {
    main: "#e83d84",
    light: "#ec5f99"
  }
};
exports.default = _default;